import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/web/src/app/global-error.tsx");
